// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__73_Y1","placeholdersHeader":"styles_placeholdersHeader__1otZW","editorStyle":"styles_editorStyle__1yGAt","placeholdersBox":"styles_placeholdersBox__3mvwL"};